import type { CSSProperties } from 'react'
import type { DataTableTheme } from '../types'

export const DEFAULT_DATA_TABLE_THEME: DataTableTheme = {
  canvas: '#FFFFFF',
  surface: 'rgba(10,10,10,0.03)',
  surfaceMuted: 'rgba(10,10,10,0.02)',
  surfaceElevated: '#FFFFFF',
  hoverSurface: 'rgba(10,10,10,0.06)',
  rowFocusSurface: 'rgba(10,10,10,0.05)',
  rowSelectedSurface: 'rgba(245,158,11,0.10)',
  rowSelectedHoverSurface: 'rgba(245,158,11,0.14)',
  text: '#0A0A0A',
  textMuted: '#6B7280',
  textSubtle: '#9CA3AF',
  accent: '#F59E0B',
  accentHover: '#D97706',
  accentText: '#0A0A0A',
  successSurface: 'rgba(5,150,105,0.14)',
  successText: '#047857',
  warningSurface: 'rgba(245,158,11,0.14)',
  warningText: '#B45309',
  dangerSurface: 'rgba(225,29,72,0.12)',
  dangerText: '#BE123C',
  inverseSurface: '#0F172A',
  inverseText: '#FFFFFF',
  highlightSurface: 'rgba(245,158,11,0.18)',
  ctaSurface: '#F59E0B',
  ctaHover: '#D97706',
  ctaText: '#0A0A0A',
  borderSoft: 'rgba(10,10,10,0.04)',
  borderStrong: 'rgba(10,10,10,0.08)',
  overlay: 'rgba(10,10,10,0.38)',
  shadowSoft: '0 -8px 32px rgba(10,10,10,0.06)',
  shadowStrong: '0 12px 40px rgba(10,10,10,0.12)',
  viewerBackdrop: 'rgba(10,10,10,0.92)',
  viewerControlSurface: 'rgba(255,255,255,0.1)',
  viewerControlHover: 'rgba(255,255,255,0.18)',
  viewerText: '#FFFFFF',
  scrollbarThumb: 'rgba(10,10,10,0.12)',
  scrollbarThumbHover: 'rgba(10,10,10,0.18)',
}

export function buildDataTableThemeVars(
  overrides?: Partial<DataTableTheme>,
): CSSProperties {
  const theme = { ...DEFAULT_DATA_TABLE_THEME, ...overrides }

  return {
    '--aera-dt-canvas': theme.canvas,
    '--aera-dt-surface': theme.surface,
    '--aera-dt-surface-muted': theme.surfaceMuted,
    '--aera-dt-surface-elevated': theme.surfaceElevated,
    '--aera-dt-hover-surface': theme.hoverSurface,
    '--aera-dt-row-focus-surface': theme.rowFocusSurface,
    '--aera-dt-row-selected-surface': theme.rowSelectedSurface,
    '--aera-dt-row-selected-hover-surface': theme.rowSelectedHoverSurface,
    '--aera-dt-text': theme.text,
    '--aera-dt-text-muted': theme.textMuted,
    '--aera-dt-text-subtle': theme.textSubtle,
    '--aera-dt-accent': theme.accent,
    '--aera-dt-accent-hover': theme.accentHover,
    '--aera-dt-accent-text': theme.accentText,
    '--aera-dt-success-surface': theme.successSurface,
    '--aera-dt-success-text': theme.successText,
    '--aera-dt-warning-surface': theme.warningSurface,
    '--aera-dt-warning-text': theme.warningText,
    '--aera-dt-danger-surface': theme.dangerSurface,
    '--aera-dt-danger-text': theme.dangerText,
    '--aera-dt-inverse-surface': theme.inverseSurface,
    '--aera-dt-inverse-text': theme.inverseText,
    '--aera-dt-highlight-surface': theme.highlightSurface,
    '--aera-dt-cta-surface': theme.ctaSurface,
    '--aera-dt-cta-hover': theme.ctaHover,
    '--aera-dt-cta-text': theme.ctaText,
    '--aera-dt-border-soft': theme.borderSoft,
    '--aera-dt-border-strong': theme.borderStrong,
    '--aera-dt-overlay': theme.overlay,
    '--aera-dt-shadow-soft': theme.shadowSoft,
    '--aera-dt-shadow-strong': theme.shadowStrong,
    '--aera-dt-viewer-backdrop': theme.viewerBackdrop,
    '--aera-dt-viewer-control-surface': theme.viewerControlSurface,
    '--aera-dt-viewer-control-hover': theme.viewerControlHover,
    '--aera-dt-viewer-text': theme.viewerText,
    '--aera-dt-scrollbar-thumb': theme.scrollbarThumb,
    '--aera-dt-scrollbar-thumb-hover': theme.scrollbarThumbHover,
  } as CSSProperties
}
